import React, { useEffect } from 'react'
import { useDataChange, useDataValue } from 'Simple/Data'
import View from './view'

export default function Logic(props) {
  let emails = useDataValue({
    context: 'emails',
    viewPath: props.viewPath,
  })
  let email = useDataValue({
    context: 'message_compose',
    path: 'email',
    viewPath: props.viewPath,
  })
  let change = useDataChange({
    context: 'message_compose',
    path: 'email',
    viewPath: props.viewPath,
  })

  useEffect(() => {
    if (!emails?.length) return
    if (emails.some(item => item.id === email)) return
    change(emails[0].id)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [email, emails])

  return <View {...props} />
}
